import { render, staticRenderFns } from "./EditMatchingOrder.vue?vue&type=template&id=93b697a0&scoped=true"
import script from "./EditMatchingOrder.vue?vue&type=script&lang=js"
export * from "./EditMatchingOrder.vue?vue&type=script&lang=js"
import style0 from "./EditMatchingOrder.vue?vue&type=style&index=0&id=93b697a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b697a0",
  null
  
)

export default component.exports